import api from '../../../../App/socket';

export const addUserProfileGroupsList = (user_id, add_groups) => (
    api.send({
        api: 'module',
        module: 'UserManagement',
        classMethod: 'AddUserToGroup',
        options: { user_id, add_groups },
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/requests/user_profile_groups_requests/add_groups_list.js